import { MapperBase } from '../../utilities/mapper-base';
import { CustodianResource } from '../resource/custodian.resource';
import { Custodian } from '../ui/custodian.model';

export class CustodianResourceToCustodianMapper extends MapperBase<CustodianResource, Custodian> {
	map(source: CustodianResource): Custodian {
		const dest = new Custodian();
		dest.name = source.name;
		dest.id = source.custodianId;
		return dest;
	}
}


